'use strict';

import angular from 'angular';
import ChangePasswordController from './changepassword.controller';
import ResendVerificationEmailController from './resendverificationemail.controller';
import ResetPasswordController from './resetpassword.controller';

export default angular.module('everlaps.other', [])
	.controller('ChangePasswordController', ChangePasswordController)
	.controller('ResendVerificationEmailController', ResendVerificationEmailController)
	.controller('ResetPasswordController', ResetPasswordController)
	.name;





// WEBPACK FOOTER //
// ./client/app/account/other/index.js